import { jsx as z } from "react/jsx-runtime";
import { createContext as A, useState as y, useCallback as L, useContext as B, useRef as F, useEffect as O } from "react";
import { z as v } from "zod";
import { twMerge as H } from "tailwind-merge";
const C = A(void 0), G = ({ children: g }) => {
  const [p, h] = y([]), k = L(
    (i, d, c) => {
      h((o) => [...o, { id: i, height: d, domTop: c }]);
    },
    []
  ), b = L(
    (i, d, c) => {
      h(
        (o) => o.map((u) => u.id === i ? { ...u, height: d, domTop: c } : u)
      );
    },
    []
  ), S = L((i) => {
    h((d) => d.filter((c) => c.id !== i));
  }, []);
  return /* @__PURE__ */ z(
    C.Provider,
    {
      value: { stickies: p, registerSticky: k, updateSticky: b, unregisterSticky: S },
      children: g
    }
  );
}, J = v.object({
  children: v.custom().optional(),
  className: v.string().optional(),
  type: v.enum(["sticky", "fixed"]).optional(),
  forwardedRef: v.any().optional(),
  style: v.custom().optional()
}).passthrough();
let T = 0;
const N = () => (T += 1, T), K = ({
  children: g,
  forwardedRef: p,
  className: h,
  style: k,
  type: b,
  ...S
}) => {
  const i = B(C);
  if (!i)
    throw new Error("StickyWrapper must be used within a StickyProvider");
  const { stickies: d, registerSticky: c, updateSticky: o, unregisterSticky: u } = i, I = F(null), n = p && typeof p == "object" && "current" in p ? p : I, [r] = y(() => N()), [x, M] = y(0), [R, j] = y(49), [q, P] = y(!1), w = () => {
    if (!n.current || typeof window > "u")
      return { height: 0, domTop: 0 };
    const e = n.current.getBoundingClientRect();
    return { height: e.height, domTop: e.top + window.scrollY };
  };
  O(() => {
    const { height: e, domTop: m } = w();
    c(r, e, m);
    const a = () => {
      const { height: t, domTop: s } = w();
      o(r, t, s);
    };
    document.readyState !== "complete" && window.addEventListener("load", a);
    let f;
    if (typeof ResizeObserver < "u") {
      const t = new ResizeObserver(() => {
        const { height: s, domTop: E } = w();
        o(r, s, E);
      });
      n.current && t.observe(n.current), f = () => {
        t && n.current && t.unobserve(n.current), u(r);
      };
    } else {
      const t = () => {
        const { height: s, domTop: E } = w();
        o(r, s, E);
      };
      window.addEventListener("resize", t), f = () => {
        window.removeEventListener("resize", t), u(r);
      };
    }
    let l = null;
    return typeof MutationObserver < "u" && n.current && (l = new MutationObserver(() => {
      const { height: t, domTop: s } = w();
      o(r, t, s);
    }), l.observe(n.current, {
      attributes: !0,
      attributeFilter: ["style", "class"]
    })), () => {
      f(), l && l.disconnect(), window.removeEventListener("load", a);
    };
  }, [r, c, o, u]), O(() => {
    if (!n.current || typeof document > "u")
      return;
    const e = () => {
      const a = Array.from(
        document.querySelectorAll("[data-sticky-wrapper]")
      ), f = a.indexOf(n.current);
      let l = 0;
      for (let t = 0; t < f; t++) {
        const s = a[t];
        l += s.offsetHeight;
      }
      M(l), j(50 - f);
    };
    e();
    const m = new MutationObserver(() => {
      e();
    });
    return m.observe(document.body, { childList: !0, subtree: !0 }), window.addEventListener("resize", e), window.addEventListener("scroll", e, { passive: !0 }), () => {
      m.disconnect(), window.removeEventListener("resize", e), window.removeEventListener("scroll", e);
    };
  }, [d, r]), O(() => {
    if (!n.current || typeof window > "u")
      return;
    const e = () => {
      const m = n.current.getBoundingClientRect(), a = Math.abs(m.top - x) < 1;
      P(a);
    };
    return window.addEventListener("scroll", e, { passive: !0 }), e(), () => window.removeEventListener("scroll", e);
  }, [x]);
  const W = {
    ...k,
    position: b || "sticky",
    top: x,
    zIndex: R
  };
  return /* @__PURE__ */ z(
    "div",
    {
      ref: n,
      style: W,
      className: H(h),
      "data-sticky-wrapper": !0,
      "data-is-stuck": q ? "true" : "false",
      ...S,
      children: g
    }
  );
};
export {
  G as StickyProvider,
  K as StickyWrapper,
  J as stickyWrapperSchema
};
//# sourceMappingURL=index.es.js.map
